export default function getSafeReturnUrl(location, origin = window.location.origin) {
    let candidate;
    if (location.state?.from) {
        candidate = `${location.state.from.pathname || ""}${location.state.from.search || ""}${location.state.from.hash || ""}` || "/";
    } else {
        candidate = new URLSearchParams(location.search).get("returnUrl") || "/";
    }

    if (!candidate.startsWith("/") || candidate.startsWith("//")) return "/";
    try {
        const parsed = new URL(candidate, origin);
        return parsed.origin === origin
            ? `${parsed.pathname}${parsed.search}${parsed.hash}`
            : "/";
    } catch {
        return "/";
    }
}
